var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Loading',{attrs:{"loading":_vm.isLoading}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('form',{attrs:{"id":"checkoutForm"}},[_c('input',{attrs:{"type":"hidden","name":"omiseToken"}}),_c('input',{attrs:{"type":"hidden","name":"omiseSource"}}),_c('button',{attrs:{"type":"submit","id":"checkoutButton"}})])
}]

export { render, staticRenderFns }